import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

function NotFound() {
	const { t } = useTranslation("common");
	return (
		<div className="container h-full w-full flex flex-col justify-center items-center gap-2 bg-gradient-account">
			<h1 className="text-5xl font-bold text-white">404</h1>
			<p className="text-xl font-semibold text-white">
				{t("common:notFoundTitle")}
			</p>
			<Link
				to="/"
				preload={false}
				className="bg-primary py-4 px-6 rounded-full text-white font-semibold hover:bg-primary/70 uppercase"
			>
				{t("common:backToHome")}
			</Link>
		</div>
	);
}

export default NotFound;
